module.exports = __webpack_public_path__ + "img/facebook.b0b26b60.webp";